import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import styles from '../styles/LoginForm.module.css'

const LoginForm = ({moderator}) => {
    const { login, authError, isLoading, user } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    /* const { moderator } = useParams(); */
    console.log(moderator);

    const handleLogin = (e) => {
        e.preventDefault();
        moderator ? (
            login(email, password)
        ) : (
            window.open(`https://fs16a.mmm-software.at:1016/orange/schueler/?txtName=${email}&txtPW=${password}&auto=1`, '_blank')
        )
        
    };

    // 🔁 после успешного входа — редирект на /angebot
    useEffect(() => {
        if (moderator && user) {
            navigate("/");
        }
    }, [user, navigate]);

    return (
        <div className={styles.login}>
            <div className={styles['login-container']}>
                <div className={styles['login-form']}>
                    <header>
                        <h1>{ moderator ? 'Mitarbeiter' : 'Schüler' }<br /><span>Login</span></h1>
                    </header>
                    {authError && moderator && (
                        <div className={styles.error}>
                            <div className={styles["error-msg"]}>{authError}</div>
                        </div>
                    )}
                    <form onSubmit={handleLogin} className={styles.formContainer}>
                        <div className={styles.inputGroup}>
                            <label className={authError && moderator ? styles.error : ''}>Benutzername:</label>
                            <input className={authError && moderator ? styles.error : ''}
                                type="text"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={authError && moderator ? styles.error : ''}>Passwort:</label>
                            <input className={authError && moderator ? styles.error : ''}
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <button className={`large button pagelink ${styles['login-button']}`} type="submit" disabled={isLoading}>
                            {isLoading ? "Einloggen..." : "Login"}
                        </button>
                    </form>
                </div>
                <div className={styles['login-info']}>
                    <h2>Dein persönliches <br /><span>Fahrschul-Portal</span></h2>
                    <p>Du kannst mit deinem Beutzernamen und Passwort einsteigen, welches du bei deiner Anmeldung per SMS erhalten hast.</p>
                    <ul>
                        <li>Deine persönlichen Ausbilungstermine</li>
                        <li>Zugang zu deinem Lernportal</li>
                        <li>Deine Anmeldemöglichkeit für Prüfungstermine, theoretische Einweisung B Dual & L17, Arzt, Erste Hilfe Kurs</li>
                        <li>Informationen & Wissenswertes</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
